import React, { useState } from 'react';
import './MessageInput.css';

const MessageInput = ({ isConnected, onSendMessage, rows = 1, placeholder = 'メッセージを入力してください...', sendButtonText = '送信' }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!message.trim() || !isConnected) return;

    onSendMessage(message.trim());
    setMessage('');
  };

  return (
    <form className="chat-input" onSubmit={handleSubmit}>
      <textarea
        id="message-input"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder={placeholder}
        disabled={!isConnected}
        rows={rows}
      />
      <button
        type="submit"
        disabled={!isConnected || !message.trim()}
      >
        {sendButtonText}
      </button>
    </form>
  );
};

export default MessageInput;
